import { render, staticRenderFns } from "./StatsView.vue?vue&type=template&id=6ec00c0d&scoped=true"
import script from "./StatsView.vue?vue&type=script&lang=ts"
export * from "./StatsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec00c0d",
  null
  
)

export default component.exports